import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { authMutationKeys } from '../constants'

export const useLoginVerifyEmailMutation = () => {
  const handleVerifyEmail = async (token) => {
    const config = {
      method: 'post',
      data: {
        token
      }
    }

    const { data } = await api('/api/me/email/verify', config)
    return data
  }

  return useMutation({
    mutationFn: async (token) => await handleVerifyEmail(token),
    mutationKey: authMutationKeys.EMAIL_MUTATION,
    retry: 0
  })
}
